export var query = "query getAppSettings($externalId: String!) {\n  appSettings(externalId: $externalId) {\n    widgetSettings\n  }\n}";
//# sourceMappingURL=getAppSettings.graphql.js.map